<template>
  <div class="tr-left-col">
    <div class="tr-left-col__head">
      <div @click="$router.push('/projects')" style="cursor:pointer">
        <i class="light-icon-presentation" style="margin-right: 4px;"></i>
        PROJECTS
      </div>
      <v-btn icon fab @click="addNewProject" dark small>
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>
    <!-- Projects Wrapper -->
    <div class="tr-left-col__projects-wrap light-scrollbar scrollable">
      <div class="tr-left-col__project" v-for="(project, projectIndex) in projects" :key="project.project_name" :class="{ '--active': project.project_path === activeProject }">
        <div class="project_label-block" @click.stop="setActiveProject(project.project_path)">
          <i class="light-icon-stack"></i>

          <span> {{ project.project_name }}</span>
          <i :class="activeProject === project.project_path ? `light-icon-chevron-down` : `light-icon-chevron-right`"></i>
        </div>
        <!-- Steps -->
        <collapse-transition>
          <div v-show="activeProject === project.project_path" class="project_steps-wrap ">
            <div v-for="step in steps" :key="step.step_name" @click="activeStep = step.step_path">
              <router-link :to="{ name: step.step_path_name, params: { projectSlug: activeProject } }" class="project-step --link"
                ><div class="project_step-label">{{ step.step_name }}</div>
              </router-link>
              <template v-if="step.sub_steps">
                <collapse-transition>
                  <div v-show="activeStep === step.step_path">
                    <div class="substeps_wrap" v-for="subStep in step.sub_steps">
                      <router-link :to="{ name: subStep.step_path_name, params: { projectSlug: activeProject } }" class="project-substep --link"
                        ><div class="project_substep-label">{{ subStep.step_name }}</div></router-link
                      >
                    </div>
                  </div>
                </collapse-transition>
              </template>
            </div>
          </div>
        </collapse-transition>
      </div>
    </div>

    <!-- <div class="tr-left-col__add-btn">
      <LvButton @click="addNewProject">Add Project</LvButton>
    </div> -->
    <!-- Overall Result Wrap -->
    <div class="tr-left-col__result-wrap">
      <div
        class="tr-left-col__result-head"
        @click="
          $router.push({
            name: 'Shadings',
          })
        "
      >
        <div>
          <i class="light-icon-settings" style="margin-right: 4px;"> </i>
          Manage Shadings
        </div>
        <v-btn icon fab dark small>
          <v-icon dark>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div
        class="tr-left-col__result-head"
        @click="
          $router.push({
            name: 'OverallResult',
          })
        "
      >
        <div>
          <i class="light-icon-chart-pie" style="margin-right: 4px;"></i>
          Overall Results
        </div>
        <v-btn icon fab dark small>
          <v-icon dark>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import LvButton from 'lightvue/button';
import { defaultSchema } from '@/store/default';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
export default {
  components: {
    LvButton,
    CollapseTransition,
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(newProjects) {
        this.$store.dispatch('setProjects', newProjects);
      },
    },
    activeProject: {
      get: function() {
        return this.$store.state.activeProject;
      },
      set: function(newActive) {
        this.$store.dispatch('setActiveProject', newActive);
      },
    },
  },
  data() {
    return {
      activeStep: '',
      steps: [
        {
          step_name: 'Step-1: Project Details',
          step_path: '/step1',
          step_path_name: 'Step1',
        },
        {
          step_name: 'Step-2: Housing Details',
          step_path: '/step2',
          step_path_name: 'Step2',
        },
        {
          step_name: 'Step-3: Openable Area Details',
          step_path: '/step3A',
          step_path_name: 'Step3A',
          sub_steps: [
            {
              step_name: '(A) Wall Surface Area',
              step_path: '/step3A',
              step_path_name: 'Step3A',
            },
            {
              step_name: '(B) Openable Area Window',
              step_path: '/step3B',
              step_path_name: 'Step3B',
            },
            {
              step_name: '(C) Openable Area Ventilator & Door',
              step_path: '/step3C',
              step_path_name: 'Step3C',
            },
          ],
        },

        {
          step_name: 'Compliance Result: WFRop & VLT',
          step_path: '/step4',
          step_path_name: 'Step4',
        },

        {
          step_name: 'Step-4: Roof & Wall Assembly Details',
          step_path: '/step5A',
          step_path_name: 'Step5A',
          sub_steps: [
            {
              step_name: '(A) Roof',
              step_path: '/step5A',
              step_path_name: 'Step5A',
            },
            {
              step_name: '(B) Wall',
              step_path: '/step5B',
              step_path_name: 'Step5B',
            },
          ],
        },
        {
          step_name: 'Step-5: RETV Calculation',
          step_path: '/step6A',
          step_path_name: 'Retv6A',
          sub_steps: [
            {
              step_name: '(A) Opaque construction',
              step_path: '/step6A',
              step_path_name: 'Retv6A',
            },
            {
              step_name: '(B) Non-Opaque construction',
              step_path: '/step6B',
              step_path_name: 'Retv6B',
            },
            {
              step_name: '(C) Shading Details',
              step_path: '/step6C',
              step_path_name: 'Retv6C',
            },
          ],
        },
        {
          step_name: 'Result',
          step_path: '/result',
          step_path_name: 'Result',
        },
      ],
      projectsCount: 0,
    };
  },
  methods: {
    setActiveProject(projectPath) {
      // this.activeProject = projectName;

      this.activeProject = this.activeProject === projectPath ? '' : projectPath;
      this.$router.push({ name: 'Step1', params: { projectSlug: projectPath } });
    },
    addNewProject() {
      let newProjectIndex = this.projects[this.projects.length - 1] ? +parseInt(this.projects[this.projects.length - 1].project_index) + 1 : 1;
      let newProject = {
        project_name: `Project ${newProjectIndex}`,
        project_icon: 'light-icon-stack',
        project_path: `project-${newProjectIndex}`,
        project_index: newProjectIndex,
        schema: { ...defaultSchema },
      };
      newProject.schema.inputs.step1.project_name = newProject.project_name;
      this.projects.push(newProject);
    },
  },
};
</script>

<style lang="scss" scoped>
/* import in CSS files [with CSS Loader] */
.tr-left-col {
  // padding: 8px;
  display: flex;
  flex-direction: column;
  background-color: #5a6978;
  color: #fff;
  width: 100%;
  height: 100vh;
  position: relative;
  .tr-left-col__head {
    margin-top: 48px;
    padding: 12px 12px 8px 12px;
    // text-align: center;

    color: #ffffff;
    font-size: 20px;
    font-weight: 400;
    background-color: rgba(52, 63, 75, 0.44);

    display: flex;
    align-items: center;
    justify-content: space-between;

    // line-height: 50px;
    //   text-align: left;
  }
}

.tr-left-col__projects-wrap {
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  margin-top: 24px;
  height: calc(100vh - 400px);
}
.tr-left-col__project {
  cursor: pointer;

  border-top: 1px solid rgba(52, 63, 75, 0.44);
  border-bottom: 1px solid rgba(52, 63, 75, 0.44);
  &:hover {
    width: 100%;
    background-color: rgba(52, 63, 75, 0.44);
  }
  &.--active {
    width: 100%;
    // font-weight: 400;
    background-color: rgba(52, 63, 75, 0.44);
    .project_label-block {
      color: #fb8c00 !important;
      font-weight: 500;
    }
  }
  .project_label-block {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 6px;
    font-size: 20px;
    font-weight: 80;
    padding-top: 12px;
    span {
      margin-left: 6px;
      margin-right: 116px;
    }
    i {
      font-size: 20px;
    }
  }
}
.project_steps-wrap {
  padding: 0px 16px 8px;
  margin-left: 8px;
  margin-top: 8px;

  transition: all 0.3s;
  overflow: hidden;
  .substeps_wrap {
    text-indent: 28px;
    margin-left: 16px;
    // height: 23px;
    // margin-top: 4px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
  }
}
.scrollable {
  height: 100%;
  overflow: auto; // here is the magic :)
}
.project-step,
.project-substep {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-left: 1px dotted #57687a;
  padding: 8px 0px;
  text-indent: 10px;
  text-decoration: none;

  &.--link {
    cursor: pointer;
    color: rgba(255, 255, 255, 0.5);
    &:hover,
    &:focus {
      color: rgba(255, 255, 255, 0.7);
      // font-weight: 500;
    }
  }
  &.router-link-active {
    color: #ffffff !important;
    font-weight: 500;
  }
}
.project_step-label {
  font-size: 14px;
  text-decoration: none;
}
a {
  font-size: 14px;
  color: #fff;
  text-decoration: none;
}
.project_substep-label {
  font-size: 12px;
  text-decoration: none;
}
.tr-left-col__add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  button {
    height: 32px;
  }
}

.tr-left-col__result-wrap {
  // margin-top: 24px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  .tr-left-col__result-head {
    font-size: 20px;
    font-weight: 400;
    padding: 12px;
    // text-align: center;
    background-color: rgba(52, 63, 75, 0.44);
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 2px solid #5a6978;
    &:hover {
      background-color: rgba(52, 63, 75, 0.74);
    }
  }
}

// ******************

@media (max-width: 768px) {
  .sidebar {
    height: 100%;
    top: 0px;
    z-index: 999;
    transform: translateX(-100%);
    transition: all 0.3s ease-in-out;
  }
  .sidebar.show-drawer {
    transform: translateX(0px);
  }
  .menu-icon {
    display: none;
  }
  .sidebar__logo {
    display: flex;
  }
}
</style>
